import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useAtedimento } from "../../../../Context/Atendimento";
import { CarregarDistribuicaoController } from "../../../../Controllers/Cobranca/FilaAtendimento/FilaAtendimentoController";
import { IFilaAtendimento } from "../../../../Interfaces/Cobranca/FilaAtendimento/FilaAtendimentoInterface";
import SpinnerComponent from "../../../Loding/Spinner";

interface IModoAtendimentoModalProps {
    setShow: (show: boolean) => void;
}
interface IFilaForm {
    filaIndex: number;
}

export default function ModoAtendimentoModal(
    props: IModoAtendimentoModalProps
) {
    const { register, handleSubmit } = useForm<IFilaForm>();
    const { iniciarAtendimentoEmFila } = useAtedimento();

    const [filaDefault, setFilaDefault] = useState(0);
    const [lstDistribuicao, setLstDistribuicao] =
        useState<Array<IFilaAtendimento>>();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        CarregarDistribuicaoController()
            .then((res) => {
                setLstDistribuicao(res);
                const ULTIMA_FILA_MA =
                    window.localStorage.getItem("ULTIMA_FILA_MA");
                const { ID_GRUPO, ID_CAMPANHA } = ULTIMA_FILA_MA
                    ? JSON.parse(ULTIMA_FILA_MA)
                    : { ID_GRUPO: -1, ID_CAMPANHA: -1 };
                setFilaDefault(
                    res.findIndex(
                        (fila) =>
                            fila.ID_GRUPO === ID_GRUPO &&
                            fila.ID_CAMPANHA === ID_CAMPANHA
                    )
                );
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    function handleFilaFormSubmit(formData: IFilaForm) {
        if (lstDistribuicao) {
            setLoading(true);
            iniciarAtendimentoEmFila(lstDistribuicao[formData.filaIndex])
                .then(() => {
                    props.setShow(false);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }

    return (
        <div>
            {!loading ? (
                lstDistribuicao ? (
                    <form onSubmit={handleSubmit(handleFilaFormSubmit)}>
                        <div className="form-group">
                            <label htmlFor="exampleSelect1">
                                Fila de Atendimento
                                <span className="text-danger">*</span>
                            </label>
                            <select
                                className="form-control"
                                name="filaIndex"
                                ref={register({
                                    required: "Insira a fila",
                                })}
                                defaultValue={filaDefault}
                            >
                                {lstDistribuicao.map((distribuicao, index) => (
                                    <option value={index} key={index}>
                                        {distribuicao.DS_GRUPO}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <button
                            className="btn btn-success col-12"
                            type="submit"
                        >
                            Iniciar Atendimento
                        </button>
                    </form>
                ) : (
                    <div className="text-center text-muted">
                        Você não tem acesso a nenhuma fila de atendimento
                    </div>
                )
            ) : (
                <SpinnerComponent />
            )}
        </div>
    );
}
